import * as React from "react";
import { useDispatch } from "react-redux";
import { setFeatureToggles } from "../../../FeatureToggles/actions.js";
const FeatureToggleContext = React.createContext({});
const useFeatureToggles = () => React.useContext(FeatureToggleContext);
function withFeatureToggles(Component) {
  const wrappedName = Component.displayName || Component.name || "Component";
  const WithFeatureToggles = (props) => /* @__PURE__ */ React.createElement(FeatureToggleContext.Consumer, null, (context) => /* @__PURE__ */ React.createElement(Component, { ...props, ...context }));
  WithFeatureToggles.displayName = `WithFeatureToggles(${wrappedName})`;
  return WithFeatureToggles;
}
const FeatureToggleProvider = ({
  children,
  featureToggles: initialFeatureToggles
}) => {
  const dispatch = useDispatch();
  const [featureToggles, setFeatureToggles$1] = React.useState(initialFeatureToggles);
  const contextValue = React.useMemo(
    () => ({ ...featureToggles, setFeatureToggles: setFeatureToggles$1 }),
    [featureToggles]
  );
  React.useEffect(() => {
    dispatch(setFeatureToggles(featureToggles));
  }, [dispatch, featureToggles]);
  return /* @__PURE__ */ React.createElement(FeatureToggleContext.Provider, { value: contextValue }, children);
};
export {
  FeatureToggleProvider,
  useFeatureToggles,
  withFeatureToggles
};
//# sourceMappingURL=Context.js.map
